import { render, staticRenderFns } from "./BadgeInput.vue?vue&type=template&id=869e434a&"
import script from "./BadgeInput.vue?vue&type=script&lang=js&"
export * from "./BadgeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports